// Feature 009: Deal Operating System
// Deal Desk real-time updates channel
import consumer from './consumer';

// Create subscription to Deal Desk channel
const createDealDeskSubscription = (callbacks) => {
  return consumer.subscriptions.create('DealDeskChannel', {
    connected() {
      console.log('Connected to Deal Desk channel');
      if (callbacks.onConnected) {
        callbacks.onConnected();
      }
    },

    disconnected() {
      console.log('Disconnected from Deal Desk channel');
      if (callbacks.onDisconnected) {
        callbacks.onDisconnected();
      }
    },

    received(data) {
      console.log('Deal Desk update received:', data);

      switch (data.type) {
        case 'status_change':
          if (callbacks.onStatusChange) {
            callbacks.onStatusChange(data.opportunity);
          }
          break;
        case 'opportunity_created':
          if (callbacks.onOpportunityCreated) {
            callbacks.onOpportunityCreated(data.opportunity);
          }
          break;
        case 'opportunity_deleted':
          if (callbacks.onOpportunityDeleted) {
            callbacks.onOpportunityDeleted(data.opportunity_id);
          }
          break;
        default:
          console.warn('Unknown Deal Desk event type:', data.type);
      }
    }
  });
};

export { createDealDeskSubscription };
export default createDealDeskSubscription;
